import { Link } from "react-router-dom";

const MarketingFooter = () => {
  return (
    <footer className="border-t border-border/15 bg-surface-1 py-20 sm:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid gap-12 grid-cols-2 md:grid-cols-4">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="mb-[18px] flex w-fit items-center gap-2.5 py-1.5">
              <img src="/logo-128.webp" alt="Sidestep Ads Logo" width="32" height="32" className="rounded-lg" />
              <span className="font-bold text-lg text-foreground tracking-tight">Sidestep Ads</span>
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-[240px]">
              AI-powered Meta and Google Ads management for performance marketers and agencies.
            </p>
          </div>
          <div>
            <h3 className="font-semibold text-foreground mb-3 text-xs tracking-widest uppercase">Product</h3>
            <ul className="text-sm">
              <li><Link to="/features" className="inline-block py-3 text-muted-foreground hover:text-foreground transition-colors">Features</Link></li>
              <li><Link to="/pricing" className="inline-block py-3 text-muted-foreground hover:text-foreground transition-colors">Pricing</Link></li>
              <li><Link to="/how-it-works" className="inline-block py-3 text-muted-foreground hover:text-foreground transition-colors">How It Works</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-foreground mb-3 text-xs tracking-widest uppercase">Company</h3>
            <ul className="text-sm">
              <li><Link to="/contact" className="inline-block py-3 text-muted-foreground hover:text-foreground transition-colors">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-foreground mb-3 text-xs tracking-widest uppercase">Legal</h3>
            <ul className="text-sm">
              <li><Link to="/privacy" className="inline-block py-3 text-muted-foreground hover:text-foreground transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="inline-block py-3 text-muted-foreground hover:text-foreground transition-colors">Terms of Service</Link></li>
              <li><Link to="/refund-policy" className="inline-block py-3 text-muted-foreground hover:text-foreground transition-colors">Money-Back Guarantee</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-border/15">
          <p className="text-sm text-muted-foreground text-center">
            © {new Date().getFullYear()} Sidestep Ads. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default MarketingFooter;
